export const COLLAPSE_SCREEN_WIDTH = 1289
